import { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import CommunityPostContainer from '../Post/CommunityPostContainer';

import CommunityApprovalComponent from './CommunityApprovalComponent';

import { onModalClose, showRenderPropsModal } from '../../Modal/actions';
import {
  confirmDeletePost,
  getCommunityList,
  getPostById,
  getPostsList,
  updatePostStatus,
} from '../actions';

import * as commonSelectors from '../../Shared/selectors';
import * as communitySelectors from '../selectors';

const LIST_KEY = 'communityPosts';

const CommunityApprovalContainer = (props) => {
  const {
    updatePostStatus,
    getItems,
    onGetPostsList,
    listParams,
    openModal,
    closeModal,
    communityList,
    location,
    getPostById,
  } = props;

  const onRefetchPosts = () => getItems(listParams);

  const onUpdatePostStatus = async (id, data) => {
    const res = await updatePostStatus(id, data);
    onRefetchPosts();
    return res;
  };

  const openPostModal = (post) => {
    if (!post?.id) return;
    openModal({
      title: post?.subject,
      maxWidth: 'md',
      closeModal,
      customTitleStyle: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      },
      render: (props) => (
        <CommunityPostContainer
          {...props}
          currentPostId={post?.id}
          post={post}
          onUpdatePostStatus={onUpdatePostStatus}
          communityList={communityList}
          onRefetchPosts={onRefetchPosts}
        />
      ),
    });
  };

  const showInitialPost = async (postId) => {
    const res = await getPostById(postId);
    if (!res?.data) return;
    openPostModal(res.data);
  };

  useEffect(() => {
    if (location?.state?.postId) showInitialPost(location.state.postId);
  }, []);

  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetPostsList(queryParams);
  };

  return (
    <CommunityApprovalComponent
      {...props}
      openPostModal={openPostModal}
      onExport={onExport}
      onUpdatePostStatus={onUpdatePostStatus}
      onRefetchPosts={onRefetchPosts}
    />
  );
};

CommunityApprovalContainer.propTypes = {
  updatePostStatus: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
  onGetPostsList: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  getPostById: PropTypes.func.isRequired,
  communityList: PropTypes.instanceOf(Array).isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  onRemovePost: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const items = communitySelectors.getPostsList(state);
  const expandedByDefault = communitySelectors.getExpandedByDefault(state);
  const communityList = communitySelectors.getCommunityUnpagedList(state);
  const listParams = commonSelectors.getListParams(state, LIST_KEY);

  return {
    listKey: LIST_KEY,
    listParams,
    items,
    communityList,
    expandedByDefault,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: () =>
    getCommunityList(dispatch, { disable_pagination: true }, false, true),
  getItems: (queryParams) =>
    getPostsList(dispatch, queryParams, { isClearPrev: true }),
  onGetPostsList: (queryParams) =>
    getPostsList(dispatch, queryParams, { isExport: true }),
  updatePostStatus: (id, data) => updatePostStatus(dispatch, id, data),
  getPostById: (postId) => getPostById(dispatch, postId),
  openModal: (props) => showRenderPropsModal(dispatch, props),
  closeModal: () => onModalClose(dispatch),
  onRemovePost: (postId) => confirmDeletePost(dispatch, postId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommunityApprovalContainer);
